/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function ViewBulkOffer(state = {}, action) {
    switch (action.type) {
    case ProductConstants.BULK_OFFER_DETAILS_SUCCESS:
        return {
            type: ProductConstants.BULK_OFFER_DETAILS_SUCCESS,
            items: action.obj,
        };
    case ProductConstants.BULK_OFFER_DETAILS_FAILURE:
        return {
            type: ProductConstants.BULK_OFFER_DETAILS_SUCCESS,
            message: action.message,
        };
    case ProductConstants.CART_SELECTED_ITEM:
        return {...state,
            selected:action.user.data
                
        };
        
    default:
        return state;
    }
}
